export const environment = {
  production: true,
  apiUrl: `https://vapor.biohackk.com/`,
  storageUrl: `https://biohackk-public.s3-ap-southeast-1.amazonaws.com/`,
  oauthUrl: `https://vapor.biohackk.com/oauth/`,
  oauthClientId: `9229259b-ae52-44b6-a89d-579e20204515`,
  oauthClientSecret: `i08rrHpsNox2U1FPXJK5XuOnMYkUrI9E0gKJIPxS`,
  imageKitEndpoint: `https://ik.imagekit.io/biohackk`
};
